// ---------------- Society Controller  Routes------------------
// auth routs
exports.SOCIETY_CONTROLLER = '/society-controller';
exports.LOGIN = '/login';
exports.PUBLIC_BILL = '/bill/:token';
exports.FORGOT_PASSWORD = '/forgot-password';
exports.SIGN_UP = '/sign-up';

// society management

exports.SOCIETY_MANAGEMENT = '/society-management';
exports.SOCIETY_MANAGEMENT_CREATE = '/society-management/create';
exports.SOCIETY_MANAGEMENT_EDIT = '/society-management/:id/edit';
exports.SOCIETY_MANAGEMENT_SETTINGS = '/society-management/:id/settings';
exports.SOCIETY_MANAGEMENT_COMMUNICATION_SETTINGS = '/society-management/:id/communication-settings';
exports.SMS_CREDIT_REQUEST = '/sms-credit-request';
exports.SMS_CREDIT_PACKAGE = '/sms-credit-package';
exports.SOCIETY_BRAND = '/society-brand';
exports.SOCIETY_BRAND_CREATE = '/society-brand/create';
exports.SOCIETY_BRAND_EDIT = '/society-brand/:id/edit';
exports.SOCIETY_LOCATION = '/society-location';
exports.SOCIETY_GATEKEEPER = '/society-gatekeeper';
exports.SOCIETY_ADMIN_USER = '/society-admin-user';
exports.SOCIETY_CTRL_COMPLAINT_CATEGORIES = '/complaint-categories';

exports.SOCIETY_MANAGE_USERS = '/society-manage-users';
exports.SOCIETY_MANAGE_TENANTS = '/society-manage-tenants';
exports.SOCIETY_MANAGE_EMPLOYEES = '/society-manage-employees';
exports.SOCIETY_EMPLOYEE_TYPES = '/employee-types';
exports.SOCIETY_ROLES_PERMISSIONS = '/roles-permissions';
exports.SOCIETY_MANAGE_VENDORS = '/society-manage-vendors';

exports.SOCIETY_PROFILE = 'profile'

// ------------Society Controller Routes----------------

// Login Page
exports.LOGIN_ADMIN = '/login/admin';
exports.LOGIN_ADMIN_FORGOT_PASSWORD = '/login/admin/forgot-password';
exports.SIGN_UP_ADMIN = '/sign-up/admin';
exports.LOGIN_EMPLOYEE = '/login/accounts';
exports.LOGIN_EMPLOYEE_FORGOT_PASSWORD = '/login/accounts/forgot-password';
exports.SIGN_UP_EMPLOYEE = '/sign-up/accounts';

// Dashboard
exports.DASHBOARD = '/'

// Society Portal Routes
exports.SOCIETY_PORTAL = '/society-portal';
exports.SOCIETY_PORTAL_LOGIN = '/login';
exports.SOCIETY_PORTAL_SIGN_UP = '/sign-up';
exports.SOCIETY_PORTAL_FORGOT_PASSWORD = '/forgot-password';


//-------Setup And Records--------
//Building
//Wings And Flats
exports.SETUP_RECORDS_WINGS_LIST = '/setup-and-records/wings-list'
exports.SETUP_RECORDS_WINGS_CREATE = '/setup-and-records/wings-create'
exports.SETUP_RECORDS_WINGS_EDIT = '/setup-and-records/wings-edit'

exports.SETUP_RECORDS_FLAT_LIST = '/setup-and-records/flat-list'
exports.SETUP_RECORDS_FLAT_CREATE = '/setup-and-records/flat-create'
exports.SETUP_RECORDS_FLAT_EDIT = '/setup-and-records/flat-edit'

// Occupant And Tenants
exports.SETUP_RECORDS_OCCUPANT_LIST = '/setup-and-records/occupant-list'
exports.SETUP_RECORDS_OCCUPANT_CREATE = '/setup-and-records/occupant-create'
exports.SETUP_RECORDS_OCCUPANT_EDIT = '/setup-and-records/occupant-edit'
// Society Portal - Setup & Records Module
exports.SOCIETY_PORTAL_SETUP_BILLING_TYPES = '/setup/billing-types';
exports.SOCIETY_PORTAL_SETUP_BILL_SERIES = '/setup/bill-series';
exports.SOCIETY_PORTAL_SETUP_DOCUMENT_SERIES = '/setup/document-series';
exports.SOCIETY_PORTAL_SETUP_CHARGE_HEADS = '/setup/charge-heads';
exports.SOCIETY_PORTAL_SETUP_FUNCTIONAL_SETTING = '/setup/functional-setting';
exports.SOCIETY_PORTAL_SETUP_TAX_RULES = '/setup/tax-rules';
exports.SOCIETY_PORTAL_SETUP_METER_READING = '/setup/meter-reading';
exports.SOCIETY_PORTAL_SETUP_OPENING_BALANCE = '/setup/opening-balance';
exports.SOCIETY_PORTAL_SETUP_BANK_ACCOUNTS = '/setup/bank-accounts';

// Society Portal - Wings & Flats
exports.SOCIETY_PORTAL_WINGS = '/wings';
exports.SOCIETY_PORTAL_FLATS = '/flats';

// Society Portal - Members
exports.SOCIETY_PORTAL_MEMBERS = '/members';
exports.SOCIETY_PORTAL_MEMBERS_ADD_OWNER = '/members/add-owner';
exports.SOCIETY_PORTAL_MEMBERS_ADD_TENANT = '/members/add-tenant';
exports.SOCIETY_PORTAL_MEMBERS_ADD_FAMILY = '/members/add-family';
exports.SOCIETY_PORTAL_MEMBERS_OWNERS = '/members/owners';
exports.SOCIETY_PORTAL_MEMBERS_TENANTS = '/members/tenants';
exports.SOCIETY_PORTAL_MEMBERS_FAMILY = '/members/family';

// Society Portal - Finance
exports.SOCIETY_PORTAL_INVOICES = '/finance/invoices';
exports.SOCIETY_PORTAL_INVOICES_CREATE = '/finance/invoices/create';
exports.SOCIETY_PORTAL_INVOICES_EDIT = '/finance/invoices/:id/edit';
exports.SOCIETY_PORTAL_INVOICES_PRINT = '/finance/invoices/:id/print';
exports.SOCIETY_PORTAL_INVOICES_BULK_PRINT = '/finance/invoices/bulk-print';
exports.SOCIETY_PORTAL_INVOICES_BULK_CREATE = '/finance/invoices/bulk-create';
exports.SOCIETY_PORTAL_CREDIT_NOTES = '/finance/credit-notes';
exports.SOCIETY_PORTAL_CREDIT_NOTES_CREATE = '/finance/credit-notes/create';
exports.SOCIETY_PORTAL_CREDIT_NOTES_PRINT = '/finance/credit-notes/:id/print';
exports.SOCIETY_PORTAL_CREDIT_NOTES_BULK_PRINT = '/finance/credit-notes/bulk-print';
exports.SOCIETY_PORTAL_CREDIT_NOTES_EDIT = '/finance/credit-notes/edit/:id';
exports.SOCIETY_PORTAL_CREDIT_NOTES_BULK_UPLOAD = '/finance/credit-notes/bulk-upload';
exports.SOCIETY_PORTAL_DEBIT_NOTES = '/finance/debit-notes';
exports.SOCIETY_PORTAL_DEBIT_NOTES_CREATE = '/finance/debit-notes/create';
exports.SOCIETY_PORTAL_DEBIT_NOTES_PRINT = '/finance/debit-notes/:id/print';
exports.SOCIETY_PORTAL_DEBIT_NOTES_BULK_PRINT = '/finance/debit-notes/bulk-print';
exports.SOCIETY_PORTAL_DEBIT_NOTES_EDIT = '/finance/debit-notes/edit/:id';
exports.SOCIETY_PORTAL_DEBIT_NOTES_BULK_UPLOAD = '/finance/debit-notes/bulk-upload';
exports.SOCIETY_PORTAL_RECEIPTS = '/finance/receipts';
exports.SOCIETY_PORTAL_RECEIPTS_CREATE = '/finance/receipts/create';
exports.SOCIETY_PORTAL_RECEIPTS_PRINT = '/finance/receipts/:id/print';
exports.SOCIETY_PORTAL_RECEIPTS_BULK_PRINT = '/finance/receipts/bulk-print';
exports.SOCIETY_PORTAL_RECEIPTS_BULK_UPLOAD = '/finance/receipts/bulk-upload';

// Society Portal - Member self-service ("My Home").
// Read-only, member-scoped views of the finance data above: the backend narrows
// each list to the flats the caller owns or occupies.
exports.SOCIETY_PORTAL_MY_HOME = '/my/home';
exports.SOCIETY_PORTAL_MY_BILLS = '/my/bills';
exports.SOCIETY_PORTAL_MY_BILL_DETAIL = '/my/bills/:id';
exports.SOCIETY_PORTAL_MY_PAYMENTS = '/my/payments';
exports.SOCIETY_PORTAL_MY_LEDGER = '/my/ledger';

// Society Portal - Complaints
exports.SOCIETY_PORTAL_COMPLAINTS = '/complaints';
exports.SOCIETY_PORTAL_COMPLAINTS_ADD = '/complaints/add';
exports.SOCIETY_PORTAL_COMPLAINTS_VIEW = '/complaints/view/:id';
exports.SOCIETY_PORTAL_COMPLAINTS_EDIT = '/complaints/edit/:id';
exports.SOCIETY_PORTAL_COMPLAINT_CATEGORIES = '/complaints/categories';
exports.SOCIETY_PORTAL_EMPLOYEE_COMPLAINTS = '/complaints/employee/:userId';
exports.SOCIETY_PORTAL_MY_COMPLAINTS = '/complaints/my';
exports.SOCIETY_PORTAL_MY_COMPLAINTS_RAISE = '/complaints/my/raise';
exports.SOCIETY_PORTAL_MY_COMPLAINTS_VIEW = '/complaints/my/view/:id';

// Society Portal - Notices & Circulars
exports.SOCIETY_PORTAL_NOTICES = '/notices';
exports.SOCIETY_PORTAL_NOTICES_ADD = '/notices/add';
exports.SOCIETY_PORTAL_NOTICES_VIEW = '/notices/view/:id';
exports.SOCIETY_PORTAL_NOTICES_EDIT = '/notices/edit/:id';
// Read-only published feed every resident/employee can open
exports.SOCIETY_PORTAL_NOTICE_BOARD = '/notices/board';
exports.SOCIETY_PORTAL_WORKING_DOCUMENTS = '/society/documents';
exports.SOCIETY_PORTAL_NOTICES_PRINT = '/notices/:id/print';

// Society Portal - Employees
exports.SOCIETY_PORTAL_EMPLOYEES = '/employees';
exports.SOCIETY_PORTAL_EMPLOYEES_ADD = '/employees/add';
exports.SOCIETY_PORTAL_EMPLOYEES_VIEW = '/employees/view/:id';
exports.SOCIETY_PORTAL_EMPLOYEES_EDIT = '/employees/edit/:id';
exports.SOCIETY_PORTAL_EMPLOYEES_WORK_LOG = '/employees/work-log';
exports.SOCIETY_PORTAL_EMPLOYEES_DAILY_TODO = '/employees/daily-todo';
exports.SOCIETY_PORTAL_ATTENDANCE_REPORT = '/employees/attendance-report';
// Employee self-service attendance (shift punch in/out)
exports.SOCIETY_PORTAL_PUNCH_ATTENDANCE = '/attendance/punch';
exports.SOCIETY_PORTAL_MY_ATTENDANCE = '/attendance/history';
// Admin attendance management (daily grid, approvals, manual punch)
exports.SOCIETY_PORTAL_MANAGE_ATTENDANCE = '/attendance/manage';
// Employee shifts — the definitions, and who is assigned to which.
exports.SOCIETY_PORTAL_SHIFTS = '/shifts';
exports.SOCIETY_PORTAL_SHIFT_ASSIGNMENTS = '/shifts/assignments';

// Society Portal - Vendors
exports.SOCIETY_PORTAL_VENDORS = '/vendors';
exports.SOCIETY_PORTAL_VENDORS_ADD = '/vendors/add';
exports.SOCIETY_PORTAL_VENDORS_VIEW = '/vendors/view/:id';
exports.SOCIETY_PORTAL_VENDORS_EDIT = '/vendors/edit/:id';
exports.SOCIETY_PORTAL_VENDOR_BILLS = '/vendors/bills';
exports.SOCIETY_PORTAL_VENDOR_BILLS_ADD = '/vendors/bills/add';
exports.SOCIETY_PORTAL_VENDOR_BILLS_VIEW = '/vendors/bills/view/:id';
exports.SOCIETY_PORTAL_VENDOR_BILLS_EDIT = '/vendors/bills/edit/:id';
exports.SOCIETY_PORTAL_VENDOR_TARIFFS = '/vendors/:id/tariffs';
exports.SOCIETY_PORTAL_VENDOR_PAYMENTS = '/vendors/payments';
exports.SOCIETY_PORTAL_VENDOR_VISITS = '/vendors/visits';
exports.SOCIETY_PORTAL_VENDOR_PAYMENTS_ADD = '/vendors/payments/add';
exports.SOCIETY_PORTAL_VENDOR_PAYMENTS_VIEW = '/vendors/payments/view/:id';
exports.SOCIETY_PORTAL_VENDOR_PAYMENTS_EDIT = '/vendors/payments/edit/:id';
exports.SOCIETY_PORTAL_VENDOR_SETTINGS = '/vendors/settings';
exports.SOCIETY_PORTAL_VENDOR_SETTINGS_CATEGORIES = '/vendors/settings/categories';
exports.SOCIETY_PORTAL_VENDOR_SETTINGS_BILLING = '/vendors/settings/billing';
exports.SOCIETY_PORTAL_VENDOR_SETTINGS_NOTIFICATIONS = '/vendors/settings/notifications';
exports.SOCIETY_PORTAL_VENDOR_SETTINGS_APPROVALS = '/vendors/settings/approvals';
// Society Portal - Task Management
exports.SOCIETY_PORTAL_TASKS = '/tasks';
exports.SOCIETY_PORTAL_TASKS_DASHBOARD = '/tasks/dashboard';
exports.SOCIETY_PORTAL_TASKS_LIST = '/tasks/list';
exports.SOCIETY_PORTAL_COMMITTEE_OVERSIGHT = '/committee/oversight';
exports.SOCIETY_PORTAL_TASKS_BOARD = '/tasks/board';
exports.SOCIETY_PORTAL_TASKS_ADD = '/tasks/add';
exports.SOCIETY_PORTAL_TASKS_VIEW = '/tasks/view/:id';
exports.SOCIETY_PORTAL_TASKS_EDIT = '/tasks/edit/:id';
exports.SOCIETY_PORTAL_TASK_PROJECTS = '/tasks/projects';
exports.SOCIETY_PORTAL_TASK_PROJECT_DETAIL = '/tasks/projects/:projectId';

// society profile
exports.SOCIETY_PORTAL_PROFILE = '/setup/profile';

// Society Portal - Roles & Permissions
exports.SOCIETY_PORTAL_ROLES = '/setup/roles';
exports.SOCIETY_PORTAL_ROLES_PERMISSIONS = '/setup/roles/:roleId/permissions';

// Society Portal - Accounts
exports.SOCIETY_PORTAL_ACCOUNTS_JOURNAL = '/accounts/journal';
exports.SOCIETY_PORTAL_ACCOUNTS_JOURNAL_ADD = '/accounts/journal/add';
exports.SOCIETY_PORTAL_ACCOUNTS_JOURNAL_EDIT = '/accounts/journal/edit/:journalId';
exports.SOCIETY_PORTAL_ACCOUNTS_JOURNAL_BULK_IMPORT = '/accounts/journal/bulk-import';
exports.SOCIETY_PORTAL_ACCOUNTS_CHART_OF_ACCOUNTS = '/accounts/chart-of-accounts';
exports.SOCIETY_PORTAL_ACCOUNTS_OPENING = '/accounts/opening';
exports.SOCIETY_PORTAL_ACCOUNTS_CLOSING = '/accounts/closing';
exports.SOCIETY_PORTAL_ACCOUNTS_MEMBER_DAYBOOK = '/accounts/member-daybook';
exports.SOCIETY_PORTAL_ACCOUNTS_FIXED_ASSETS = '/accounts/fixed-assets';
exports.SOCIETY_PORTAL_ACCOUNTS_FIXED_ASSETS_ADD = '/accounts/fixed-assets/add';
exports.SOCIETY_PORTAL_ACCOUNTS_FIXED_ASSETS_EDIT = '/accounts/fixed-assets/edit/:id';
exports.SOCIETY_PORTAL_ACCOUNTS_CASH_AND_BANK = '/accounts/cash-and-bank';
exports.SOCIETY_PORTAL_ACCOUNTS_CASH_AND_BANK_BOOK = '/accounts/cash-and-bank/:accountId';
exports.SOCIETY_PORTAL_ACCOUNTS_INVESTMENTS = '/accounts/investments';
exports.SOCIETY_PORTAL_ACCOUNTS_RECONCILIATION = '/accounts/reconciliation';
exports.SOCIETY_PORTAL_ACCOUNTS_RECONCILIATION_DETAIL = '/accounts/reconciliation/:brsId';

// Society Portal - Accounts Reports
exports.SOCIETY_PORTAL_ACCOUNTS_REPORTS_INCOME_EXPENDITURE = '/accounts-reports/income-expenditure';
exports.SOCIETY_PORTAL_ACCOUNTS_REPORTS_BALANCE_SHEET = '/accounts-reports/balance-sheet';
exports.SOCIETY_PORTAL_ACCOUNTS_REPORTS_TRIAL_BALANCE = '/accounts-reports/trial-balance';
exports.SOCIETY_PORTAL_ACCOUNTS_REPORTS_GROUP_LEDGER = '/accounts-reports/group-ledger';
exports.SOCIETY_PORTAL_ACCOUNTS_REPORTS_ACCOUNT_LEDGER = '/accounts-reports/account-ledger';
exports.SOCIETY_PORTAL_ACCOUNTS_REPORTS_MONTHLY_INCOME = '/accounts-reports/monthly-income';
exports.SOCIETY_PORTAL_ACCOUNTS_REPORTS_MONTHLY_EXPENDITURE = '/accounts-reports/monthly-expenditure';
exports.SOCIETY_PORTAL_ACCOUNTS_REPORTS_MONTHLY_INCOME_EXPENDITURE = '/accounts-reports/month-wise-income-expenditure';

// Society Portal - Compliance (Flat Transfer & Share Certificates)
exports.SOCIETY_PORTAL_FLAT_TRANSFER_WIZARD = '/flats/:flatId/transfer';
exports.SOCIETY_PORTAL_FLAT_TRANSFER_HISTORY = '/flats/:flatId/transfer-history';
exports.SOCIETY_PORTAL_FLAT_TRANSFER_DETAIL = '/compliance/flat-transfers/:id';
exports.SOCIETY_PORTAL_SHARE_CERTIFICATES = '/compliance/share-certificates';
exports.SOCIETY_PORTAL_SHARE_CERTIFICATE_DETAIL = '/compliance/share-certificates/:id';

// Society Portal - Reports
exports.SOCIETY_PORTAL_REPORTS_MEMBER_LEDGER = '/reports/member-ledger';
exports.SOCIETY_PORTAL_REPORTS_INVOICE = '/reports/invoice';
exports.SOCIETY_PORTAL_REPORTS_INVOICE_AGING = '/reports/invoice-aging';
exports.SOCIETY_PORTAL_REPORTS_INTEREST = '/reports/interest-calculation';
exports.SOCIETY_PORTAL_REPORTS_RECEIPT = '/reports/receipt';
exports.SOCIETY_PORTAL_REPORTS_CD_NOTE = '/reports/credit-debit-note';
exports.SOCIETY_PORTAL_REPORTS_GST = '/reports/gst';
exports.SOCIETY_PORTAL_REPORTS_RECONCILIATION = '/reports/reconciliation';

//

// Society Portal - Visitor Management (VMS)
exports.SOCIETY_PORTAL_VISITORS = '/visitors';
exports.SOCIETY_PORTAL_VISITORS_ADD = '/visitors/add';
exports.SOCIETY_PORTAL_VISITORS_VIEW = '/visitors/view/:id';
exports.SOCIETY_PORTAL_VISITORS_EDIT = '/visitors/edit/:id';

// Society Portal - VMS (visits, authorisations, gate logs)
exports.SOCIETY_PORTAL_VISITS = '/visitors/visits';
exports.SOCIETY_PORTAL_VISITS_ADD = '/visitors/visits/add';
exports.SOCIETY_PORTAL_VISITS_VIEW = '/visitors/visits/view/:id';
exports.SOCIETY_PORTAL_PRE_APPROVALS = '/visitors/pre-approvals';
exports.SOCIETY_PORTAL_PRE_APPROVALS_ADD = '/visitors/pre-approvals/add';
exports.SOCIETY_PORTAL_PRE_APPROVALS_EDIT = '/visitors/pre-approvals/edit/:id';
exports.SOCIETY_PORTAL_GATE_PASSES = '/visitors/gate-passes';
exports.SOCIETY_PORTAL_GATE_PASSES_ADD = '/visitors/gate-passes/add';
exports.SOCIETY_PORTAL_GATE_PASSES_EDIT = '/visitors/gate-passes/edit/:id';
exports.SOCIETY_PORTAL_DELIVERIES = '/visitors/deliveries';
exports.SOCIETY_PORTAL_CABS = '/visitors/cabs';
exports.SOCIETY_PORTAL_VMS_ACTIVITY_LOGS = '/visitors/activity-logs';
exports.SOCIETY_PORTAL_VMS_SETTINGS = '/visitors/settings';
